import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: _ctx.as,
    color: _ctx.color,
    variant: _ctx.variant,
    class: _normalizeClass([..._ctx.sizeClasses, ..._ctx.baseClasses]),
    title: _ctx.label,
    "aria-label": _ctx.label,
    onClick: _ctx.onClick
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ]),
    _: 3
  }, 8, ["as", "color", "variant", "class", "title", "aria-label", "onClick"]))
}